import React from "react";
import PropTypes from "prop-types";
import { Button, Typography, Stack, Box } from "@mui/joy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

const StancePage = ({ setPage, setStance, bill }) => {
  const handleStanceSelection = (stance) => {
    setStance(stance);
    setPage("contact");
  };

  return (
    <>
      <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#171a1c", mb: "6px" }}>
        What&apos;s Your Position?
      </Typography>
      <Typography sx={{ fontSize: "15px", color: "#535862", lineHeight: 1.6, mb: "28px" }}>
        Tell your representative how you feel about{" "}
        <strong style={{ color: "#171a1c" }}>{bill?.title || "this bill"}</strong>.
      </Typography>

      <Stack spacing="12px">
        <Button
          fullWidth
          size="lg"
          startDecorator={<ThumbUpIcon />}
          onClick={() => handleStanceSelection("support")}
          sx={{
            backgroundColor: "#1e6f3e",
            color: "white",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "6px",
            minHeight: "52px",
            "&:hover": { backgroundColor: "#165730" },
          }}
        >
          I support this bill
        </Button>
        <Button
          fullWidth
          size="lg"
          startDecorator={<ThumbDownIcon />}
          onClick={() => handleStanceSelection("oppose")}
          sx={{
            backgroundColor: "#c1121f",
            color: "white",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "6px",
            minHeight: "52px",
            "&:hover": { backgroundColor: "#a00f1a" },
          }}
        >
          I oppose this bill
        </Button>
      </Stack>

      <Box sx={{ mt: "20px" }}>
        <Button
          variant="plain"
          color="neutral"
          onClick={() => setPage("address")}
          sx={{ fontSize: "15px", fontWeight: 500, px: 0 }}
        >
          ← Back
        </Button>
      </Box>
    </>
  );
};

StancePage.propTypes = {
  setStance: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  bill: PropTypes.object.isRequired,
};

export default StancePage;
